/**
 * Satisfaction Guarantee JavaScript
 * If CTA has a real link, navigate to it.
 * Otherwise, scroll to product section.
 */

class SatisfactionGuarantee {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.attachEventListeners());
    } else {
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    const ctaButtons = document.querySelectorAll(".guarantee-section__cta");

    ctaButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleCtaClick(e, button));
    });
  }

  handleCtaClick(event, button) {
    const href = button.getAttribute("href");

    // If there's a real URL, let it navigate
    if (href && href !== "#" && href.trim() !== "") {
      return; // do NOT preventDefault
    }

    // Otherwise, keep your old scroll behavior
    event.preventDefault();
    this.scrollToProduct();
    return false;
  }

  scrollToProduct() {
    const productSection = document.querySelector(
      ".shopify-section .product, " +
        '.shopify-section [data-section-type="product"], ' +
        "main#MainContent .product-template, " +
        "main#MainContent .product, " +
        "#ProductSection, " +
        "#shopify-section-product-template, " +
        ".product-section"
    );

    if (productSection) {
      productSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new SatisfactionGuarantee();
});
